module.exports = __webpack_public_path__ + "static/media/cacao-group.0f1b8983.jpg";